import { render } from "./AppContent.vue?vue&type=template&id=f5f55338&scoped=true&ts=true"
import script from "./AppContent.vue?vue&type=script&lang=ts"
export * from "./AppContent.vue?vue&type=script&lang=ts"

import "./AppContent.vue?vue&type=style&index=0&id=f5f55338&scoped=true&lang=scss"

import exportComponent from "D:\\Users\\asato\\Documents\\GitHub\\suite_totalling_web\\totalling_web\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f55338"]])

export default __exports__